import React, { memo } from 'react';

import './spinner.css';

export const Loader = () => (
	<div className="spinner">
		<div className="bounce1" />
		<div className="bounce2" />
		<div className="bounce3" />
	</div>
);

const Spinner = () => (
	<div className="spinner-container">
		<Loader />
	</div>
);

export const SpinnerCenter = () => (
	<div className="spinner-center">
		<div className="bounce1" />
		<div className="bounce2" />
		<div className="bounce3" />
	</div>
);

export const LoaderSingle = () => (
	<div className="spinner-single">
		<div className="bounce1" />
		<div className="bounce2" />
		<div className="bounce3" />
	</div>
);

export default memo(Spinner);
